import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.initializeEditor()
  }

  disconnect() {
    // Remove any existing TinyMCE instances
    if (window.tinymce) {
      const editor = window.tinymce.get(this.inputTarget.id)
      if (editor) {
        editor.remove()
      }
    }
  }

  initializeEditor() {
    // First ensure the textarea has an ID
    if (!this.inputTarget.id) {
      this.inputTarget.id = `tinymce_${Math.random().toString(36).substr(2, 9)}`
    }

    // Load TinyMCE from local assets if not already loaded
    if (!window.tinymce) {
      const script = document.createElement('script')
      script.src = '/assets/tinymce/tinymce.min.js'
      script.onload = () => {
        this.setupEditor()
      }
      script.onerror = () => {
        console.error('Failed to load TinyMCE from local assets. Make sure assets are built properly.')
      }
      document.head.appendChild(script)
    } else {
      this.setupEditor()
    }
  }

  setupEditor() {
    // Remove any existing instance for this textarea
    const existingEditor = window.tinymce.get(this.inputTarget.id)
    if (existingEditor) {
      existingEditor.remove()
    }

    window.tinymce.init({
      selector: `#${this.inputTarget.id}`,
      license_key: 'gpl',
      promotion: false,
      branding: false,
      menubar: false,
      plugins: 'lists link code',
      toolbar: 'undo redo | bold italic underline | bullist numlist | link | code | removeformat',
      height: this.inputTarget.dataset.editorHeight || 300,
      min_height: 200,
      max_height: 600,
      resize: true,
      content_style: `
        body { 
          font-family: system-ui, -apple-system, sans-serif; 
          font-size: 14px; 
          line-height: 1.6;
          padding: 12px;
        }
      `,
      setup: (editor) => {
        // Update the hidden textarea on change
        editor.on('change', () => {
          editor.save()
        })
        
        // Save when form is submitted
        const form = this.inputTarget.closest('form')
        if (form) {
          form.addEventListener('submit', () => {
            editor.save()
          }, { once: true })
        }
      }
    })
  }
}